<template>
  <div class="addClaimExpense">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">费用报销申请</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="resDetail.state == 1">审批中</div>
          <div class="state2" v-if="resDetail.state == 2">已归档</div>
          <div class="state3" v-if="resDetail.state == 3">退回</div>
          <div class="state4" v-if="resDetail.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">费用报销审批流程</div>
        <blank height="7"> </blank>
        <a-button
          class="detial-top-btn"
          type="primary"
          icon="printer"
          v-if="resDetail.state == 2"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="resDetail.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照要求填写相关信息，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">表单基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >部门/单位名称 <span class="required">*</span></span
            >
            <a-tooltip placement="topLeft" :title="resDetail.departmentName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="resDetail.departmentName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="resDetail.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >收款人/经办人<span class="required">*</span></span
            >
            <a-input
              class="w300"
              placeholder="请输入收款人/经办人姓名"
              v-model="resDetail.collectionName"
              disabled
              @change="eightyfive('collectionName', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >费用报销日期<span class="required">*</span></span
            >
            <!--  -->
            <a-date-picker
              allowClear
              class="w300"
              v-model="resDetail.applyTime"
              valueFormat="YYYY-MM-DD"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">付款方式<span class="required">*</span></span>

            <a-select
              class="w300"
              placeholder="请选择"
              v-model="resDetail.paymentMethod"
              :disabled="disabled"
            >
              <a-select-option
                v-for="item in paymentwayValList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item
            label="其他付款方式"
            v-if="resDetail.paymentMethod == '1799'"
          >
            <a-input
              class="w300"
              placeholder="请注明其他付款方式"
              v-model="resDetail.paymentMethodName"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >收款人/收款单位名称<span class="required">*</span></span
            >
            <!-- <a-select
              mode="combobox"
              style="width: 215px"
              placeholder="请选择收款人/收款单位名称"
              v-model="resDetail.collectionCompanyName"
              :disabled="disabled"
              @change="CompanyNameChange"
            >
              <a-select-option
                v-for="item in CollectionList"
                :value="item.collectionCompanyName"
                :key="item.id"
                :label="item.id"
              >
                {{ item.collectionCompanyName }}
              </a-select-option>
            </a-select> -->
            <a-input
              style="width: 215px"
              placeholder="请选择收款人/收款单位名称"
              v-model="resDetail.collectionCompanyName"
              :disabled="disabled"
              @change="upChange"
            />
            <a-button
              v-if="resDetail.state != 1"
              type="primary"
              class="ml20"
              @click="getCollect()"
            >
              选择
            </a-button>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">收款单位账号<span class="required">*</span></span
            ><a-input
              class="w300"
              placeholder="请输入账号"
              v-model="resDetail.collectionCompanyNumber"
              :disabled="disabled"
              @change="upChange"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">开户银行<span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请输入开户银行"
              v-model="resDetail.bank"
              :disabled="disabled"
              @change="upChange"
            />
          </a-descriptions-item>
          <a-descriptions-item label="地址">
            <a-input
              class="w300"
              placeholder="请输入地址"
              v-model="resDetail.address"
              :disabled="disabled"
              @change="eightyfive('address', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item label="电话">
            <a-input
              class="w300"
              placeholder="请输入手机号码"
              v-model="resDetail.phoneNumber"
              :disabled="disabled"
              @blur="changePhoneNumber()"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >合计金额（小写）<span class="required">*</span></span
            >
            <a-input-number
              :min="0"
              :max="1000000000"
              class="w300"
              placeholder="请输入金额"
              v-model="resDetail.fee"
              disabled
              @change="changeNum"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >合计金额（大写）<span class="required">*</span></span
            >
            <a-input
              class="w300"
              placeholder="金额（大写）"
              v-model="resDetail.totalFee"
              :disabled="true"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >原始凭单粘贴簿（或附件）张数<span class="required">*</span></span
            >
            <a-input-number
              :min="0"
              :max="1000000"
              class="w300"
              placeholder="请输入张数"
              v-model="resDetail.enableNum"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item label="备注">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="resDetail.remark"
              :disabled="disabled"
              @change="eightyfive('remark', 200)"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <blank height="2"> </blank>
      <div class="detial-cont-view">
        <reim-items
          :disabled="disabled"
          v-model="reimbursementAssociations"
          :resDetail="resDetail.reimbursementAssociations"
        ></reim-items>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <!-- 附件 -->
      <accessories-table
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
      ></accessories-table>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <!-- 审批流 表单流程 -->
      <div class="detial-cont-view">
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && resDetail.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!resDetail.state && !disabled"
            :loading="confirmLoading && resDetail.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!resDetail.state && !disabled"
            :loading="loading && resDetail.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && resDetail.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ resDetail.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="resDetail.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="resDetail.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button> -->
          <!-- <a-button
            v-if="resDetail.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="resDetail.state == 2"
      :id="id"
      mobilePath="/pages/workbench/expenseClaim/details?id="
      skipPageReqFlag="/ClaimExpenseDetial"
    >
      <div class="print-title">费用报销单</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="部门名称" :span="1.5">
              {{ resDetail.departmentName }}
            </a-descriptions-item>
            <a-descriptions-item label="收款人/经办人" :span="1.5">
              {{ resDetail.collectionName }}
            </a-descriptions-item>
            <a-descriptions-item label="申请日期" :span="3">
              {{ resDetail.applyTime }}
            </a-descriptions-item>
            <a-descriptions-item label="付款方式" :span="3">
              现金【 <span v-if="resDetail.paymentMethod == '1700'">√</span> 】
              汇款【<span v-if="resDetail.paymentMethod == '1701'">√</span> 】
              支票【 <span v-if="resDetail.paymentMethod == '1702'">√</span>】
              其他方式
              <span v-if="resDetail.paymentMethod == '1799'"
                >【{{ resDetail.paymentMethodName }}】</span
              >
            </a-descriptions-item>

            <a-descriptions-item label="收款人/收款单位名称" :span="1.5">
              {{ resDetail.collectionCompanyName }}
            </a-descriptions-item>
            <a-descriptions-item label="收款单位账号" :span="1.5">
              {{ resDetail.collectionCompanyNumber }}
            </a-descriptions-item>
            <a-descriptions-item label="地址" :span="3">
              {{ resDetail.address }}
            </a-descriptions-item>
            <a-descriptions-item label="开户行" :span="1.5">
              {{ resDetail.bank }}
            </a-descriptions-item>
            <a-descriptions-item label="电话" :span="1.5">
              {{ resDetail.phoneNumber }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            :pagination="false"
            :columns="columns2"
            :data-source="reimbursementAssociations"
            :row-key="(record) => record.id"
            bordered
          >
            <div slot="order" slot-scope="text, record, index">
              {{ index + 1 }}
            </div>
          </a-table>
        </div>
        <div class="printd-item">
          <a-descriptions bordered>
            <a-descriptions-item label="合计金额：（小写）￥" :span="3">
              {{ resDetail.fee }}
            </a-descriptions-item>
            <a-descriptions-item label="合计金额：（大写）￥" :span="3">
              {{ resDetail.totalFee }}
            </a-descriptions-item>
            <a-descriptions-item label="原始凭单粘贴簿（或附件）张数" :span="3">
              {{ resDetail.enableNum }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
    <a-modal
      v-model="visible"
      title="请选择收款账号"
      width="800px"
      :footer="null"
    >
      <a-input
        allowClear
        class="w300 mr20"
        placeholder="请输入收款人/收款单位名称"
        v-model="header"
      />
      <a-button
        type="primary"
        @click="collectionMit"
        :loading="collectionloading"
      >
        查询</a-button
      >
      <a-table
        class="mt20"
        :rowKey="(record) => record.id"
        :pagination="false"
        :columns="columns3"
        :data-source="listData"
        :loading="collectionloading"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="setItCollection(record)"
          >
            确定
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :size="size"
          :total="total"
          @change="pageChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  expenseReimbursementGet,
  expenseReimbursementUpdate,
  addClaimExpenseApi,
  sysCollection,
  myCollection
} from './api/api'
import AccessoriesTable from '@/components/accessories-table/index.vue'
import FormBaseInfo from './components/formBaseInfo.vue'
import ReimItems from './components/reimItems.vue'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
import { validatorPhone, formatDateNoDetails } from '@/assets/js/auth'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    FormBaseInfo,
    ReimItems,
    approvalSubmission,
    approvalChart,
    AccessoriesTable
  },
  data() {
    return {
      ifAbleAdd: false,
      confirmLoading: false,
      loading: false,
      tabnum: '1',
      reimbursementAssociations: [],
      id: '',
      resDetail: {},
      source: null,
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      approvalChartData: [],
      // CollectionList: [], //收款资料表
      // 审批流部分,
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      columns2: [
        {
          title: '序号',
          dataIndex: 'order',
          key: 'order',
          scopedSlots: { customRender: 'order' }
        },
        {
          title: '报销事项说明',
          dataIndex: 'reimbursementDesc',
          key: 'reimbursementDesc',
          align: 'left'
        },
        {
          title: '金额',
          dataIndex: 'reimbursementFee',
          key: 'reimbursementFee',
          align: 'left'
        }
      ],
      columns3: [
        {
          title: '收款人/收款单位名称',
          dataIndex: 'collectionCompanyName',
          key: 'collectionCompanyName',
          align: 'left',
          ellipsis: true
        },
        {
          title: '收款方单位账号',
          dataIndex: 'collectionCompanyNumber',
          key: 'collectionCompanyNumber',
          align: 'left',
          ellipsis: true
        },
        {
          title: '开户行',
          dataIndex: 'bank',
          key: 'bank',
          align: 'left',
          ellipsis: true
        },

        {
          key: 'operation',
          scopedSlots: { customRender: 'action' },
          title: '操作',
          width: 80,
          align: 'center'
        }
      ],
      visible: false,
      collectionloading: false,
      header: '',
      listData: [], //账号列表
      page: 1,
      size: '5',
      total: 0,
      formDTOList: [],
      updateList: [], //申请项目文件附件
      pIsedit: ''
    }
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      paymentwayValList: (state) => state.bytype.paymentwayValList // 付款方式
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.resDetail.state == 1 || this.resDetail.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.getorganizationUserList()
    this.getpaymentwayVal()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    // sysCollection().then((res) => {
    //   if (res.data.code == 0) {
    //     this.CollectionList = res.data.data;
    //   }
    // });
    if (this.id) {
      this.expenseReimbursementGetFn()
    } else {
      //新增
      let date = new Date()
      this.$set(this.resDetail, 'applyTime', formatDateNoDetails(date))
      this.$set(this.resDetail, 'paymentMethod', '1701')
      this.$set(
        this.resDetail,
        'collectionName',
        this.$store.state.app.userInfo.fullName
      )
      this.$set(
        this.resDetail,
        'organizationId',
        this.$store.state.app.organizationId
      )
      myCollection().then((res) => {
        //获取当前人的收款资料
        if (res.data.code == 0) {
          if (res.data.data && res.data.data.length > 0) {
            this.$set(
              this.resDetail,
              'collectionCompanyName',
              res.data.data[0].collectionCompanyName
            )
            this.$set(
              this.resDetail,
              'collectionCompanyNumber',
              res.data.data[0].collectionCompanyNumber
            )
            this.$set(this.resDetail, 'bank', res.data.data[0].bank)
          }
        }
      })
    }
  },

  methods: {
    // 选中当前账号
    setItCollection(record) {
      this.$set(
        this.resDetail,
        'collectionCompanyName',
        record.collectionCompanyName
      )
      this.$set(
        this.resDetail,
        'collectionCompanyNumber',
        record.collectionCompanyNumber
      )
      this.$set(this.resDetail, 'bank', record.bank)
      this.visible = false
    },

    collectionMit() {
      this.page = 1
      this.collectionList()
    },
    getCollect() {
      this.header = ''
      this.page = 1
      this.collectionList()
      this.visible = true
    },
    // 拉账号表
    collectionList() {
      this.collectionloading = true
      const params = {}
      params.page = this.page
      params.size = this.size
      params.header = this.header

      sysCollection(params).then((res) => {
        this.collectionloading = false
        if (res.data.code == 0) {
          this.listData = res.data.data
          this.total = res.data.count
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.collectionList()
    },
    updataFee() {
      this.changeNum()
      this.$forceUpdate()
    },
    ...mapActions(['getorganizationUserList', 'getpaymentwayVal']),
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '费用报销-' +
        this.resDetail.collectionName +
        this.$printFormatDate(new Date())
    },
    // CompanyNameChange(e, option) {
    //   let id = option.componentOptions.propsData.label;
    //   this.CollectionList.forEach((v, k) => {
    //     if (v.id == id) {
    //       let { collectionCompanyNumber, bank } = v;
    //       this.resDetail.collectionCompanyNumber = collectionCompanyNumber;
    //       this.resDetail.bank = bank;
    //       this.upChange();
    //       return;
    //     }
    //   });
    //   // collectionCompanyNumber 收款单位账号   bank 开户银行
    // },

    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.resDetail[v].length > maxNum) {
        this.resDetail[v] = this.resDetail[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    upChange() {
      this.$forceUpdate()
    },
    changePhoneNumber() {
      let isPhone = validatorPhone(this.resDetail.phoneNumber)
      if (!this.resDetail.phoneNumber) {
        return
      }
      if (!isPhone) {
        this.resDetail.phoneNumber = ''
        this.$message.error('请输入正确的手机号！')
      }
    },
    changeNumMoneyToChinese(money) {
      let that = this
      var cnNums = new Array(
        '零',
        '壹',
        '贰',
        '叁',
        '肆',
        '伍',
        '陆',
        '柒',
        '捌',
        '玖'
      ) //汉字的数字
      var cnIntRadice = new Array('', '拾', '佰', '仟') //基本单位
      var cnIntUnits = new Array('', '万', '亿', '兆') //对应整数部分扩展单位
      var cnDecUnits = new Array('角', '分', '毫', '厘') //对应小数部分单位
      // var cnInteger = '整' //整数金额时后面跟的字符
      var cnInteger = '' //整数金额时后面跟的字符
      var cnIntLast = '元' //整型完以后的单位
      var maxNum = 999999999999999.9999 //最大处理的数字
      var IntegerNum //金额整数部分
      var DecimalNum //金额小数部分
      var ChineseStr = '' //输出的中文金额字符串
      var parts //分离金额后用的数组，预定义
      var Symbol = '' //正负值标记
      if (money == '') {
        return ''
      }

      money = parseFloat(money)
      if (money >= maxNum) {
        // that.$message.warning('超出最大处理数字')
        // alert('超出最大处理数字')
        return ''
      }
      if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger
        return ChineseStr
      }
      if (money < 0) {
        money = -money
        Symbol = '负 '
      }
      money = money.toString() //转换为字符串
      if (money.indexOf('.') == -1) {
        IntegerNum = money
        DecimalNum = ''
      } else {
        parts = money.split('.')
        IntegerNum = parts[0]
        DecimalNum = parts[1].substr(0, 4)
      }
      if (parseInt(IntegerNum, 10) > 0) {
        //获取整型部分转换
        var zeroCount = 0
        var IntLen = IntegerNum.length
        for (var i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1)
          var p = IntLen - i - 1
          var q = p / 4
          var m = p % 4
          if (n == '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0]
            }
            zeroCount = 0 //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
          }
          if (m == 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q]
          }
        }
        ChineseStr += cnIntLast
        //整型部分处理完毕
      }
      if (DecimalNum != '') {
        //小数部分
        var decLen = DecimalNum.length
        for (var i = 0; i < decLen; i++) {
          var n = DecimalNum.substr(i, 1)
          if (n != '0') {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i]
          }
        }
      }
      if (ChineseStr == '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger
      } else if (DecimalNum == '') {
        ChineseStr += cnInteger
      }
      ChineseStr = Symbol + ChineseStr

      return ChineseStr
    },
    changeNum() {
      if (this.resDetail.fee > 10000000000) {
        this.$message.warning('金额最大为1000000000')
      }
      this.resDetail.totalFee = this.changeNumMoneyToChinese(this.resDetail.fee)
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.expenseReimbursementGetFn()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    // 保存
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
      } else {
        this.pIsedit = '2'
      }
      this.addClaimExpenseApiFn(1)
    },
    // 提交
    submitFn() {
      this.addClaimExpenseApiFn(2)
    },
    // 申请接口
    addClaimExpenseApiFn(type) {
      let params = this.resDetail
      // 判断当前表格是否含有空数据
      if (
        this.reimbursementAssociations &&
        this.reimbursementAssociations.length != 0
      ) {
        this.reimbursementAssociations.forEach((item, index) => {
          if (item.reimbursementFee == '' && item.reimbursementDesc == '') {
            this.$message.warning('请先输入当前报销事项分类')
            this.ifAbleAdd = true
          } else {
            this.ifAbleAdd = false
          }
        })
      }
      if (this.ifAbleAdd) {
        return
      }
      if (!params.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!params.collectionName) {
        this.$message.error('请填写收款人/经办人')
        return
      }
      if (!params.applyTime) {
        this.$message.error('请填写费用报销日期')
        return
      }
      if (!params.paymentMethod) {
        this.$message.error('请填写付款方式')
        return
      }
      if (!params.collectionCompanyName) {
        this.$message.error('请填写收款人/收款单位名称')
        return
      }
      if (!params.collectionCompanyNumber) {
        this.$message.error('请填写收款单位账号')
        return
      }
      if (!params.bank) {
        this.$message.error('请填写开户银行')
        return
      }
      if (!params.fee) {
        this.$message.error('请填写合计金额')
        return
      }
      if (!params.enableNum) {
        this.$message.error('请填写原始凭单粘贴簿（或附件）张数')
        return
      }
      //检测付款说明必须大于两个字
      let aaa = this.reimbursementAssociations.every((item) => {
        return item.reimbursementDesc && item.reimbursementDesc.length > 1
      })
      if (!aaa) {
        this.$message.error('报销描述必须大于两个字')
        return
      }
      this.confirmLoading = true
      params.expenseReimbursementAttachment = this.updateList
      params.reimbursementAssociations = this.reimbursementAssociations
      params.appId = this.$route.meta.appId
      params.skipPageReqFlag = '/ClaimExpenseDetial'
      params.draft = type
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (params.id) {
        expenseReimbursementUpdate(params, this.id).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (params.state > 0) {
                this.expenseReimbursementGetFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  params.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (params.draft == 2) {
                  this.$message.success('提交成功')
                  this.$router.push('/ClaimExpense')
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == params.organizationId) {
            organizationName = item.organizationname
          }
        })
        params.departmentName = organizationName
        addClaimExpenseApi(params).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('添加成功')
            if (params.draft == 2) {
              this.$router.push('/ClaimExpense')
            } else {
              //首次添加
              this.id = res.data.data
              this.expenseReimbursementGetFn()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    },

    // 详情
    expenseReimbursementGetFn() {
      expenseReimbursementGet(this.id).then((res) => {
        if (res.status == 200) {
          this.resDetail = res.data.data
          this.updateList = this.resDetail.expenseReimbursementAttachment
          this.reimbursementAssociations =
            this.resDetail.reimbursementAssociations
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    callback(key) {
      //   console.log(key, this.tabnum);
    },
    goback() {
      this.$router.push('/ClaimExpense')
    }
  }
}
</script>

<style lang="scss" scoped>
.addClaimExpense {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
// 打印内容不能嵌套写样式

.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>

<!-- <style scoped>
/* 
  打印弹窗的所有字体颜色加深，table 和 descriptions
*/
/deep/ .ant-descriptions-view table tbody tr th,
/deep/ .ant-descriptions-view table tbody tr td {
  color: #000000 !important;
}

/deep/ .ant-table-column-title,
/deep/ .ant-table-body table tbody tr th,
/deep/ .ant-table-body table tbody tr td {
  color: #000000 !important;
}

/* 
  打印弹窗的所有表格边框颜色加深 table 和 descriptions
*/
/deep/.ant-descriptions-bordered .ant-descriptions-view {
  border-radius: 0;
  border: 1px solid #333333 !important;
  border-right: none !important;
}
/deep/ .ant-descriptions-bordered .ant-descriptions-row {
  border-bottom: 1px solid #333333 !important;
}
/deep/ .ant-descriptions-bordered .ant-descriptions-row:last-child {
  border-bottom: none !important;
}

/deep/ .ant-descriptions-bordered .ant-descriptions-item-label,
.ant-descriptions-bordered .ant-descriptions-item-content {
  border-right: 1px solid #333333 !important;
}

.printd-item /deep/ .ant-descriptions-item-content {
  border-right: 1px solid #333333 !important;
}

.printd-item /deep/ .ant-descriptions-item-content :last-child {
  border-right: none !important;
}

.printd-item /deep/ .ant-table-body table {
  border: 1px solid #333333 !important;
  border-right: none !important;
  border-bottom: none !important;
  border-radius: 0 !important;
}
.printd-item /deep/ .ant-table-tbody > tr > td {
  border-right: 1px solid #333333 !important;
  border-bottom: 1px solid #333333 !important;
}
.printd-item /deep/ .ant-table-thead > tr > th {
  border-right: 1px solid #333333 !important;
  border-bottom: 1px solid #333333 !important;
}

.printd-item /deep/ .ant-table-thead > tr:first-child > th:last-child {
  border-radius: none !important;
}
/* 当表格size为small的时候 padding不应该有左右边距 否则会有样式冲突 */
.printd-item /deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}
</style> -->

<!-- 打印弹窗样式  scoped-->
<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/ClaimExpense/detial.vue